module.exports = __webpack_public_path__ + "img/newletter-23.53e3d49.png";